import { inject, Injectable } from '@angular/core';

import { OfferKind } from '@core/offers-types';
import { DialogConfigOptions, DialogService, DialogWidth } from '@core/user-interface-legacy';

import { OfferSlotsLimitDialogComponent } from './offer-slots-limit-dialog.component';

@Injectable()
export class SlotsLimitDialogOpenerService {
  private readonly dialog = inject(DialogService);

  public open(
    config: DialogConfigOptions | null,
    data: {
      showSaveAsDraft?: boolean;
      isTrial?: boolean;
      skipRedirectAfterPurchase?: boolean;
      triggeredFromBulkCount?: number;
    },
  ) {
    return this.dialog.openCustom(
      OfferSlotsLimitDialogComponent,
      { width: DialogWidth.Small, ...config },
      { offerKind: OfferKind.Job, ...data },
    ).afterClosed;
  }
}
